import { variant } from 'styled-system';

export const kind = variant({
  prop: 'kind',
  variants: {
    'tab-1': {
      bg: 'tab1Bg',
      borderWidth: 'tab1BorderWidth',
      borderColor: 'tab1BorderColor',
      borderRadius: 'tab1BorderRadius',
      color: 'tab1TextColor',
      fontWeight: 'tab1FontWeight',
      '&:hover': {
        bg: 'tab1HoverBg',
        borderColor: 'tab1HoverBorderColor',
        color: 'tab1HoverTextColor',
      },
      '&:active': {
        bg: 'tab1ActiveBg',
        borderColor: 'tab1ActiveBorderColor',
        color: 'tab1ActiveTextColor',
      },
      '&[aria-disabled="true"]': {
        bg: 'tab1DisabledBg',
        borderColor: 'tab1DisabledBorderColor',
        color: 'tab1DisabledTextColor',
      },
      '&[aria-selected="true"]': {
        bg: 'tab1SelectedFocusBg',
        borderColor: 'tab1SelectedFocusBorderColor',
        color: 'tab1SelectedTextColor',
        fontWeight: 'tab1SelectedFontWeight',
        '&:hover': {
          bg: 'tab1SelectedHoverBg',
          borderColor: 'tab1SelectedHoverBorderColor',
          color: 'tab1SelectedHoverTextColor',
        },
        '&:active': {
          bg: 'tab1SelectedActiveBg',
          borderColor: 'tab1SelectedActiveBorderColor',
          color: 'tab1SelectedActiveTextColor',
        },
        '&[aria-disabled="true"]': {
          bg: 'tab1SelectedDisabledBg',
          borderColor: 'tab1SelectedDisabledBorderColor',
          color: 'tab1SelectedDisabledTextColor',
        },
      },
    },
    'tab-2': {
      bg: 'tab2Bg',
      borderWidth: 'tab2BorderWidth',
      borderColor: 'tab2BorderColor',
      borderRadius: 'tab2BorderRadius',
      color: 'tab2TextColor',
      fontWeight: 'tab2FontWeight',
      '&:hover': {
        bg: 'tab2HoverBg',
        borderColor: 'tab2HoverBorderColor',
        color: 'tab2HoverTextColor',
      },
      '&:active': {
        bg: 'tab2ActiveBg',
        borderColor: 'tab2ActiveBorderColor',
        color: 'tab2ActiveTextColor',
      },
      '&[aria-disabled="true"]': {
        bg: 'tab2DisabledBg',
        borderColor: 'tab2DisabledBorderColor',
        color: 'tab2DisabledTextColor',
      },
      '&[aria-selected="true"]': {
        bg: 'tab2SelectedFocusBg',
        borderColor: 'tab2SelectedFocusBorderColor',
        color: 'tab2SelectedTextColor',
        fontWeight: 'tab2SelectedFontWeight',
        '&:hover': {
          bg: 'tab2SelectedHoverBg',
          borderColor: 'tab2SelectedHoverBorderColor',
          color: 'tab2SelectedHoverTextColor',
        },
        '&:active': {
          bg: 'tab2SelectedActiveBg',
          borderColor: 'tab2SelectedActiveBorderColor',
          color: 'tab2SelectedActiveTextColor',
        },
        '&[aria-disabled="true"]': {
          bg: 'tab2SelectedDisabledBg',
          borderColor: 'tab2SelectedDisabledBorderColor',
          color: 'tab2SelectedDisabledTextColor',
        },
      },
    },
    'tab-3': {
      bg: 'tab3Bg',
      borderWidth: 'tab3BorderWidth',
      borderColor: 'tab3BorderColor',
      borderRadius: 'tab3BorderRadius',
      color: 'tab3TextColor',
      fontWeight: 'tab3FontWeight',
      '&:hover': {
        bg: 'tab3HoverBg',
        borderColor: 'tab3HoverBorderColor',
        color: 'tab3HoverTextColor',
      },
      '&:active': {
        bg: 'tab3ActiveBg',
        borderColor: 'tab3ActiveBorderColor',
        color: 'tab3ActiveTextColor',
      },
      '&[aria-disabled="true"]': {
        bg: 'tab3DisabledBg',
        borderColor: 'tab3DisabledBorderColor',
        color: 'tab3DisabledTextColor',
      },
      '&[aria-selected="true"]': {
        bg: 'tab3SelectedFocusBg',
        borderColor: 'tab3SelectedFocusBorderColor',
        color: 'tab3SelectedTextColor',
        fontWeight: 'tab3SelectedFontWeight',
        '&:hover': {
          bg: 'tab3SelectedHoverBg',
          borderColor: 'tab3SelectedHoverBorderColor',
          color: 'tab3SelectedHoverTextColor',
        },
        '&:active': {
          bg: 'tab3SelectedActiveBg',
          borderColor: 'tab3SelectedActiveBorderColor',
          color: 'tab3SelectedActiveTextColor',
        },
        '&[aria-disabled="true"]': {
          bg: 'tab3SelectedDisabledBg',
          borderColor: 'tab3SelectedDisabledBorderColor',
          color: 'tab3SelectedDisabledTextColor',
        },
      },
    },
  },
});

export const vertSize = variant({
  prop: 'vertSize',
  variants: {
    'size-1': {
      pt: 'tabSize1PaddingTop',
      px: 'tabSize1PaddingX',
      pb: 'tabSize1PaddingBottom',
      lineHeight: 'tabSize1LineHeight',
      '& svg': {
        width: 'tabSize1IconSize',
        height: 'tabSize1IconSize',
      },
    },
    'size-2': {
      pt: 'tabSize2PaddingTop',
      px: 'tabSize2PaddingX',
      pb: 'tabSize2PaddingBottom',
      lineHeight: 'tabSize2LineHeight',
      '& svg': {
        width: 'tabSize2IconSize',
        height: 'tabSize2IconSize',
      },
    },
    'size-3': {
      pt: 'tabSize3PaddingTop',
      px: 'tabSize3PaddingX',
      pb: 'tabSize3PaddingBottom',
      lineHeight: 'tabSize3LineHeight',
      '& svg': {
        width: 'tabSize3IconSize',
        height: 'tabSize3IconSize',
      },
    },
    'size-4': {
      pt: 'tabSize4PaddingTop',
      px: 'tabSize4PaddingX',
      pb: 'tabSize4PaddingBottom',
      lineHeight: 'tabSize4LineHeight',
      '& svg': {
        width: 'tabSize4IconSize',
        height: 'tabSize4IconSize',
      },
    },
  },
});

export type Kind = 'tab-1' | 'tab-2' | 'tab-3';
export type VertSize = 'size-1' | 'size-2' | 'size-3' | 'size-4';

const defaultAdditionalStyles = {
  'size-1': {
    minHeight: 'defaultTabSize1MinHeight',
    fontSize: 'defaultTabSize1FontSize',
  },
  'size-2': {
    minHeight: 'defaultTabSize2MinHeight',
    fontSize: 'defaultTabSize2FontSize',
  },
  'size-3': {
    minHeight: 'defaultTabSize3MinHeight',
    fontSize: 'defaultTabSize3FontSize',
  },
  'size-4': {
    minHeight: 'defaultTabSize4MinHeight',
    fontSize: 'defaultTabSize4FontSize',
  },
};

const tab1AdditionalStyles = {
  'size-1': {
    minHeight: 'tab1Size1MinHeight',
    fontSize: 'tab1Size1FontSize',
  },
  'size-2': {
    minHeight: 'tab1Size2MinHeight',
    fontSize: 'tab1Size2FontSize',
  },
  'size-3': {
    minHeight: 'tab1Size3MinHeight',
    fontSize: 'tab1Size3FontSize',
  },
  'size-4': {
    minHeight: 'tab1Size4MinHeight',
    fontSize: 'tab1Size4FontSize',
  },
};

export const getAdditionalStyles = ({
  kind,
  vertSize,
}: {
  kind: Kind;
  vertSize: VertSize;
}) => {
  if (kind === 'tab-1') {
    return tab1AdditionalStyles[vertSize];
  }
  return defaultAdditionalStyles[vertSize];
};
// делаем без использования variant, т.к. для одинаковых vertSize, в зависимости от разных kind, должны отдавать разные fontSize и minHeight
